import { ReactNode } from 'react';
import { SVGIconType } from '../../../constants/svgIcon';
import { SvgIcon } from '../SVGIcon';

import styles from './AppBar.module.css';

type Props = {
  leading?: ReactNode;
  title?: ReactNode;
  trailing?: ReactNode;
  withBack?: boolean;
  onClickBack?: () => void;
};

export const AppBar = ({
  leading,
  title,
  trailing,
  withBack = true,
  onClickBack,
}: Props) => {
  const handleBack = () => {
    window.history.back();
  };

  return (
    <div className={styles.appBar}>
      <div className={styles.leading}>
        {withBack && (
          <button
            className={styles.backButton}
            onClick={onClickBack ?? handleBack}
          >
            <SvgIcon
              name={SVGIconType.Arrow}
              stroke="black"
              width={24}
              height={24}
            />
          </button>
        )}
        {leading}
      </div>
      <div className={styles.title}>{title}</div>
      <div className={styles.trailing}>{trailing}</div>
    </div>
  );
};
